<template>
    <div class="w3-margin-top">

        <loading v-bind:dspin="displayLoading"></loading>

        <div class="w3-container zero-left zero-bottom flow-margin-top  w3-animate-opacity" v-if="!displayLoading">
            <p class="zero-top flow-left blue-text w-90pc flow-form-inline-input">
                <i class="fa fa-map-marker-alt fa-lg flow-margin-right"></i>
                <span v-if="location.position">
                    {{ $t("lastSeen") }}: <b>{{location.position.displayName}}</b> at <b> {{location.time}}</b>, <b>{{location.date}}</b>
                </span>
                <span v-else>
                    {{ $t("locationUnknown") }}
                </span>
            </p>
        </div>
        <form class="flow-form-cum-panel zero-left  w3-animate-opacity"  v-if="!displayLoading">
            <div class="w3-container zero-left zero-bottom zero-top">
                <div class="zero-bottom zero-top w-50pc w3-show-inline-block flow-form-inline-input">
                    <p class="flow-padding-bottom zero-top w-100pc">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("movePatient") }}</label>
                        <flow-select
                                :items="items"
                                :valueKey="'name'"
                                :valueKeyIndex="'id'"
                                :callback="setLocationOrStatus">
                        </flow-select>
                    </p>
                </div>
                <!--<div class="w-5pc flow-form-inline-input pad-top-26pc flow-padding-left flow-margin-right">-->
                    <!--&lt;!&ndash;<img src="/images/013.png" alt="" class="flow-tag-image flow-padding-left">&ndash;&gt;-->
                <!--</div>-->
                <p class="w-45pc flow-form-inline-input zero-top w3-right">
                    <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("tag") }}</label>
                    <input id="patient-ticket" class="w3-input" type="text" placeholder="Tag" v-model="patient.ticket">
                    <span v-if="ticketError" class="w3-text-red"> {{ticketError}} </span>
                </p>
            </div>

            <div class="w3-container zero-left zero-bottom zero-top">
                <p class="w-98pc flow-form-inline-input">
                    <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("comments") }}</label>
                    <textarea id="patient-comment" class="w3-input w3-border" placeholder="Comment"  v-model="patient.comment"></textarea>
                </p>
            </div>

            <div class="w3-container zero-left zero-bottom zero-top">
                <p class="w-98pc flow-form-inline-input w3-left">
                    <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("patientMessage") }}</label>
                    <input class="w3-input w-90pc w3-show-inline-block flow-padding-left" type="text" placeholder="Call Message" v-model="message">
                    <i class="w3-right cursor-pointer fa fa-volume-up fa-inverse flow-blue-color w3-ripple fa-2x w3-margin-left" @click="callPatient" :title="$t('callPatient')"></i>
                </p>
            </div>

            <div class="w3-container zero-left zero-bottom flow-margin-top-8" v-if="isDH">
                <p class="w-50pc flow-form-inline-input zero-top">
                    <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("assignedRoom") }}</label>
                    <input id="patient-room" class="w3-input" type="text" :placeholder="$t('assignedRoom')" v-model="patient.assignedRoom">
                </p>
                <p class="w-45pc flow-form-inline-input zero-top w3-right" v-if="patient.assignedBed">
                    <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("bed") }}</label>
                    <input id="patient-bed" class="w3-input w3-light-gray" readonly v-model="patient.assignedBed">
                </p>
            </div>

            <div class="w3-container zero-bottom zero-top">
                <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top w3-large"
                        @click.prevent="savePatient">
                    <i class="fa fa-save flow-green-active-color">
                        <span><b class="flow-margin-left">{{$t('save')}}</b></span>
                    </i>
                </button>
            </div>


        </form>
    </div>
</template>

<script>
    import FlowSelect from "../common/FlowSelect";
    import Vue from 'vue';
    import Loading from "../common/Loading";
    import {EventBus} from "../../main";

    let frc = Vue.prototype.$frc;

    export default {
        name: "PatientInfo",
        components: {FlowSelect, Loading},
        props: ['propsPatientId'],
        data: function(){
            return{
                initialPatient: {
                    ticket: '',
                    comment: ''
                },
                patient: {},
                displayLoading: true,
                location: {},
                items: [],
                selectNone: {id: 1, name: this.$t("none") , type: 'none'},
                status: null,
                waitingArea: null,
                ticketError: null,
                message: ''
            }
        },
        computed: {
            isDH() {
                return Vue.prototype.$showStatusOverviewMenu;
            }
        },
        watch: {
            propsPatientId: function () {
                this.ticketError = null;
                if(this.propsPatientId !== undefined) {
                    this.getPatientInfo(this.propsPatientId);
                }
            }
        },
        mounted() {
            this.items.push(this.selectNone);
            var currentPatientId = this.propsPatientId;

            if (!this.propsPatientId) {
                currentPatientId = this.$route.params.id;
            }

            this.getPatientInfo(currentPatientId);

            EventBus.$on("patientUpdated", this.getPatientInfo);
            EventBus.$on("appointmentDeleted", this.getPatientInfo);
            EventBus.$on("appointmentAdded", this.getPatientInfo);
        },
        beforeDestroy() {
            EventBus.$off("patientUpdated", this.getPatientInfo);
            EventBus.$off("appointmentDeleted", this.getPatientInfo);
            EventBus.$off("appointmentAdded", this.getPatientInfo);
        },
        methods: {
            getPatientInfo: function (patientId) {
                var app= this;
                app.displayLoading = true;
                app.items = [this.selectNone];
                app.status = null;
                app.waitingArea = null;

                frc.getPatient(patientId).then(function(res) {
                    var calledPatient = JSON.parse(JSON.stringify(res.data));
                    EventBus.$emit("patientCalled", calledPatient);

                    app.patient = res.data;
                    var entry = res.data.properties.entry;
                    entry.forEach(function (e) {
                        app.patient[e.key] = e.value;
                        app.initialPatient[e.key] = e.value;
                    });
                    app.location = res.data.lastSeen;
                    app.initialPatient.comment = res.data.comment;
                    app.initialPatient.ticket = res.data.ticket;
                    app.displayLoading = false;

                    if (app.patient.possibleStatusChanges){
                        app.pushStatusesInSelectItems(app.patient.possibleStatusChanges);
                    }
                    if (app.patient.possibleWaitingAreas){
                        app.pushWAInSelectItems(app.patient.possibleWaitingAreas);
                    }
                    if (app.patient.manualCallMessage) {
                        app.message = app.patient.manualCallMessage;
                    } else {
                        app.message = app.$t("defaultMessage");
                    }
                    if (res.data.ticket === app.patient.ticket) {
                        app.ticketError = null;
                    }
                }).catch(function(e) {
                    app.displayLoading = false;
                });

            },
            savePatient: function () {
                this.ticketError = null;
                this.updatePatient();

            },
            pushStatusesInSelectItems: function (statuses) {
                for (var i=0; i < statuses.length; i++) {
                    this.items.push({id: statuses[i], name: this.$t(statuses[i]), type: 'status'});
                }
            },
            pushWAInSelectItems: function (was) {
                for (var i=0; i < was.length; i++) {
                    var itemName = this.$t("moveTo", {'waitingArea': was[i].displayName});
                    this.items.push({id: was[i].id, name: itemName, type: 'WA'});
                }
            },
            updatePatient: function() {
                var app = this;
                var ticket = this.initialPatient.ticket === this.patient.ticket ? null : this.patient.ticket;
                var comment = this.initialPatient.comment === this.patient.comment ? null : this.patient.comment;
                var room = this.initialPatient.assignedRoom === this.patient.assignedRoom ? null : this.patient.assignedRoom;

                var status = this.status;
                var posId = this.waitingArea;
                var entry = [];

                if (!ticket && !comment && !status && !posId && !room) {
                    Vue.notifyWarn({title: app.$t('NothingToUpdate')});
                    return;
                }

                if (room) {
                    entry = [{key: "assignedRoom", value: room}];
                }

                app.displayLoading = true;
                frc.updatePatient(this.patient.id, ticket, comment, status, posId, entry).then(function(res) {
                    var response = res.data;
                    app.displayLoading = false;
                    console.log(JSON.stringify(response, null, 2));
                    app.showNotifications(response);
                    if (response.ticketUpdated === true || response.statusUpdated === true || response.positionUpdated === true) {
                        EventBus.$emit("patientUpdated", app.patient.id);
                    }
                }).catch(function(ex) {
                    app.displayLoading = false;
                });
            },
            showNotifications: function (response) {
                var successes = [];
                var errors = [];

                if (response.ticketError) {
                    this.ticketError = this.$t(response.ticketError.restCodes[0]);
                }
                if (response.statusError) {
                    errors.push(this.$t(response.statusError.restCodes[0]));
                }
                if (response.positionError) {
                    errors.push(this.$t(response.positionError.restCodes[0]));
                }
                if (response.commentUpdated === true) {
                    successes.push(this.$t("comments"));
                }
                if (response.positionUpdated === true) {
                    successes.push(this.$t("location"));
                }
                if (response.statusUpdated === true) {
                    successes.push(this.$t("status"));
                }
                if (response.ticketUpdated === true) {
                    successes.push(this.$t("tag"));
                }
                if (successes.length > 0) {
                    Vue.notifySuccess({title: this.$t("successfullyUpdated"), message: successes});
                }
                if (errors.length > 0) {
                    Vue.notifyError({title: this.$t("failedToUpdate"), message: errors});
                }
            },
            setLocationOrStatus: function (chosenItem) {
                this.waitingArea = null;
                this.status = null;

                if (chosenItem.type === "WA") {
                    this.waitingArea = chosenItem.id;
                } else if(chosenItem.type === "status") {
                    this.status = chosenItem.id;
                }
            },
            callPatient: function () {
                var app = this;
                frc.notifyPatient(this.patient.id, this.message). then(function (res) {
                    var message = app.$t("patientCalled");
                    Vue.notifySuccess({title: message});
                }).catch(function (ex) {
                    console.log(JSON.stringify(ex.response.data , null , 2));
                    var cause = ex.response.data.restCodes[0];
                    Vue.notifyError({title: app.$t(cause)});
                });
            }
        }
    }
</script>